"use client";
import Section from "../components/Section";
import {
  Card,
  CardContent,
  CardHeader,
  Grid2,
  List,
  ListItem,
  CardActions,
  Typography,
  Box,
  Button,
  Divider,
  Popover,
  CallToAction,
  RadioGroup,
  Radio,
} from "@repo/ui";
import { QuestionIcon } from "@spoctech/icons";
import { useState } from "react";
import QuestionNumber from "../components/user/QuestionNumber";

const Question = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  // const open = Boolean(anchorEl);

  const [selectedValue, setSelectedValue] = useState("1");

  const handleRadioChange = (value: string) => {
    setSelectedValue(value);
  };

  return (
    <Section>
      <Grid2 container spacing={6}>
        <Grid2 size={{ sm: 12, md: 3, lg: 3 }}>
          <Card>
            <CardHeader className="flex justify-center gap-x-2 text-base font-bold">
              <div onClick={handleClick} role="button" tabIndex={0}>
                <QuestionIcon className="size-6 !text-primary-light" />
              </div>
              <Popover>
                <div className="p-4 sui-border sui-mt-2 sui-z-10 sui-bg-white sui-rounded-lg">
                  <h1>Content visible area</h1>
                </div>
              </Popover>
              <span className="!text-black">Questions</span>
            </CardHeader>
            <CardContent className="!bg-slate-50">
              <Box className="grid grid-cols-5 gap-3">
                <QuestionNumber value={1} color="attempted" />
                <QuestionNumber value={2} color="not-attempted" />
                <QuestionNumber value={3} color="attempted" />
                <QuestionNumber value={4} color="attempted" />
                <QuestionNumber value={5} color="attempted" />
                <QuestionNumber value={6} color="attempted" />
                <QuestionNumber value={7} color="attempted" />
                <QuestionNumber value={8} color="not-answered" />
                <QuestionNumber value={9} color="not-answered" />
                <QuestionNumber value={10} color="not-answered" />
                <QuestionNumber value={11} color="not-answered" />
                <QuestionNumber value={12} color="not-answered" />
                <QuestionNumber value={13} color="attempted" />
                <QuestionNumber value={14} color="attempted" />
                <QuestionNumber value={15} color="attempted" />
                <QuestionNumber value={16} color="attempted" />
                <QuestionNumber value={17} color="attempted" />
                <QuestionNumber value={18} color="current" />
                <QuestionNumber value={19} color="current" />
                <QuestionNumber value={20} color="current" />
              </Box>
            </CardContent>
            <CardActions>
              <List column={2}>
                <ListItem className="text-black text-sm items-center gap-x-2">
                  <span className="bg-emerald-600 size-3 rounded-full"></span>
                  Attempted
                </ListItem>
                <ListItem className="text-black text-sm items-center gap-x-2">
                  <span className="bg-slate-200 size-3 rounded-full"></span>
                  Not attempted
                </ListItem>
                <ListItem className="text-black text-sm items-center gap-x-2">
                  <span className="bg-orange-200 size-3 rounded-full"></span>
                  Not answered
                </ListItem>
                <ListItem className="text-black text-sm items-center gap-x-2">
                  <span className="bg-blue-300 size-3 rounded-full"></span>
                  Current
                </ListItem>
              </List>
            </CardActions>
          </Card>
        </Grid2>

        <Grid2 size={{ sm: 12, md: 9, lg: 9 }}>
          <Typography
            paragraph
            className="text-xl font-semi-bold text-zinc-900"
          >
            20. What is the purpose of scrum sprint review meeting?
          </Typography>
          <RadioGroup
            name="radio-group"
            variant="options"
            variantOptionLabel="alphabet"
            defaultValue={selectedValue}
            //@ts-ignore
            onChange={handleRadioChange}
          >
            <Radio
              value="1"
              label="It setups planning for the entire team for success"
            />
            <Radio
              value="2"
              label="To learn the current progress of every team member"
            />
            <Radio
              value="3"
              label="To show the customers and stakeholders the work they have accomplished"
            />
            <Radio value="4" label="All of above" />
          </RadioGroup>

          <Box className="flex justify-between mt-6">
            <CallToAction
              onSaveLabel="Next"
              onCancelLabel="Previous"
              className="flex-row-reverse sm:justify-between w-full justify-normal"
            />
          </Box>
        </Grid2>
        <Divider />
        <Grid2 size={{ sm: 12, md: 12, lg: 12 }} className="text-right">
          <Button
            label="Submit test"
            variant="contained"
            color="primary"
            className="justify-center sm:justify-center"
          />
        </Grid2>
      </Grid2>
    </Section>
  );
};

export default Question;
